import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "13",
  height: "12",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#464646",
      stroke: "#464646",
      "stroke-width": ".5",
      d: "M6.253 9.378c.173 0 .346-.069.463-.2l5.347-5.479a.62.62 0 0 0 .187-.442.62.62 0 0 0-.629-.635.66.66 0 0 0-.449.18L5.88 8.21h.74L1.328 2.8a.63.63 0 0 0-.45-.18.62.62 0 0 0-.628.636c0 .173.07.325.187.45l5.347 5.47c.13.132.29.201.47.201Z"
    }, null, -1)
  ])))
}
export default { render: render }